import { Axios } from 'axios';
import { CONTROLLER_API_PREFIX, UNI_API_CONTROLLER } from 'app/constants';
import type { FilterKindEnum, FilterGroups, Filters } from 'app/domain';

class FiltersService {
  readonly #httpClient: Axios;
  readonly #baseUrl: string;

  constructor(httpClient: Axios) {
    this.#httpClient = httpClient;
    this.#baseUrl = `/${CONTROLLER_API_PREFIX}/${UNI_API_CONTROLLER.filters}`;
  }

  async getAll(params: Record<string, string>): Promise<Filters> {
    const response = await this.#httpClient.get<Filters>(this.#baseUrl, {
      params,
    });
    return response.data;
  }

  async getByType(
    filterKind: FilterKindEnum,
    params: Record<string, string>
  ): Promise<FilterGroups> {
    const response = await this.#httpClient.get<FilterGroups>(
      `${this.#baseUrl}/${filterKind}`,
      { params }
    );
    return response.data;
  }
}

export default FiltersService;
